import { Form, Switch } from "antd";
import React from "react";

const AllowReadingManualEntry: React.FC = () => {
  return (
    <Form.Item
      name="allowReadingManualEntry"
      label="Allow Reading Manual Entry?"
      valuePropName="checked"
    >
      <Switch />
    </Form.Item>
  );
};

export default AllowReadingManualEntry;
